/**
 * <s-announcement-rotator> — cycles [data-announcement] children every data-interval ms.
 * Inactive messages are faded out, aria-hidden and their links removed from tab order.
 * Pauses while hovered or focused, and when the tab is hidden.
 */
class SAnnouncementRotator extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-announcement]')];
    if (this.items.length < 2) return;
    this.index = 0;
    this.paused = false;
    const pause = () => { this.paused = true; };
    const resume = () => { this.paused = false; };
    this.addEventListener('mouseenter', pause);
    this.addEventListener('mouseleave', resume);
    this.addEventListener('focusin', pause);
    this.addEventListener('focusout', resume);
    this.show(0);
    this.timer = setInterval(() => {
      if (!this.paused && !document.hidden) this.show((this.index + 1) % this.items.length);
    }, Number(this.dataset.interval) || 4000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  show(next) {
    this.index = next;
    this.items.forEach((item, i) => {
      const active = i === next;
      item.classList.toggle('opacity-0', !active);
      item.classList.toggle('pointer-events-none', !active);
      if (active) item.removeAttribute('aria-hidden');
      else item.setAttribute('aria-hidden', 'true');
      item.querySelectorAll('a').forEach((a) => {
        if (active) a.removeAttribute('tabindex');
        else a.setAttribute('tabindex', '-1');
      });
    });
  }
}

if (!customElements.get('s-announcement-rotator')) customElements.define('s-announcement-rotator', SAnnouncementRotator);
